<template>
  <div>
    <Ad1/>
    <div class="tabBtn">
      <a v-bind:class="{active:tab==0}" @click="changeTab(0)">投票</a>
      <a v-bind:class="{active:tab==1}" @click="changeTab(1)">履歴</a>
    </div>
    <div v-if="tab==0" class="tab">
      <h4>基準価格{{standardTimeStr}}</h4>
      <p class="price">{{standardPrice}}円/BTC</p>
      <h4>現在価格{{nowTimeStr}}</h4>
      <p class="price">{{nowPrice}}円/BTC</p>
      <h3>{{nextTimeStr}}の価格は<br class="sp">上がる？下がる？</h3>
      <Timer v-bind:targetTime="standardTime + 1200" />
      <Vote v-bind:targetTime="standardTime + 1200" />
    </div>
    <div v-if="tab==1" class="tab">
      <table class="historyTable">
        <tr>
          <th>時間</th>
          <th>あなたの投票</th>
          <th>正解</th>
          <th>結果</th>
        </tr>
        <tr v-for="h in history" :key="h.createdAt">
          <th>
            {{h.createdAt}}
          </th>
          <td>
            <div  v-if="h.vote" v-bind:class="{'voteBtn': true,  high: h.vote == 'high', low: h.vote == 'low'}">
              <img src="../assets/arrow.svg"/>
            </div>
            <span v-if="!h.vote">-</span>
          </td>
          <td>
            <div v-bind:class="{'voteBtn': true,  high: h.result == 'high', low: h.result == 'low'}">
              <img src="../assets/arrow.svg"/>
            </div>
          </td>
          <td>
            {{!h.vote? '未投票': ''}}
            {{h.vote && h.vote==h.result && h.result? '正解': ''}}
            {{h.vote && h.vote!=h.result && h.result? '不正解': ''}}
          </td>
        </tr>
      </table>
    </div>
  </div>
</template>

<script>
import Rates from '../class/Rates'
import Timer from './Timer'
import Ad1 from './ad/Ad1'
import Vote from './Vote'
import firebase from 'firebase/app'

import { DateTime, Settings } from 'luxon'
Settings.defaultLocale = 'ja'

export default {
  name: 'Charts',
  data: function () {
    return {
      nowPrice: Rates.nowPrice,
      nowTime: Rates.nowTime,
      standardPrice: Rates.standardPrice,
      standardTime: Rates.standardTime,
      nextTime: Rates.nextTime,
      rates: Rates.rates,
      isLoading: false,
      tab: 0,
      history: []
    }
  },
  components: {
    Timer,
    Ad1,
    Vote
  },
  computed: {
    standardTimeStr: function () {
      let time = DateTime.fromMillis(this.standardTime * 1000, { locale: 'ja' })
      if (!time.invalidReason) {
        return time.toLocaleString(DateTime.DATETIME_SHORT)
      } else {
        return '----/--/-- --:--'
      }
    },
    nextTimeStr: function () {
      let time = DateTime.fromMillis(this.nextTime * 1000, { locale: 'ja' })
      if (!time.invalidReason) {
        return time.toLocaleString(DateTime.DATETIME_SHORT)
      } else {
        return '----/--/-- --:--'
      }
    },
    nowTimeStr: function () {
      let time = DateTime.fromMillis(this.nowTime * 1000, { locale: 'ja' })
      if (!time.invalidReason) {
        return time.toLocaleString(DateTime.DATETIME_SHORT)
      } else {
        return '----/--/-- --:--'
      }
    }
  },
  created: function () {
  },
  mounted: function () {
    const db = firebase.firestore()
    let date = new Date(Date.now() - 1800000)
    let userId = firebase.auth().currentUser.uid
    db.collection('btc_standard_rates').where('createdAt', '<=', date).orderBy('createdAt', 'desc').limit(10).get().then(val => {
      this.history = []
      val.forEach(doc => {
        let data = doc.data()
        let tarmID = this.unix2Time(data.createdAt.seconds, 1)
        db.collection('tarmData').doc(tarmID).collection('vote').doc(userId).get().then(val => {
          if (val.exists) {
            let voteData = val.data()
            data.vote = voteData.vote
          }
          data.createdAt = this.unix2Time(data.createdAt.seconds)
          this.history.push(data)
        })
      })
    })
    Promise.all([
      Rates.updateChart(),
      Rates.updateStandardPrice()
    ]).then(res => {
      this.nowPrice = Rates.getNowPrice()
      this.nowTime = Rates.getNowTime()
      this.standardPrice = Rates.getStandardPrice()
      this.standardTime = Rates.getStandardTime()
      this.nextTime = Rates.getNextTime()
      this.$forceUpdate()
    }).catch(console.error)
  },
  methods: {
    changeTab: function (_id) {
      this.tab = _id
    },
    unix2Time: function (unixtime, type = 0) {
      if (type === 0) {
        return DateTime.fromMillis(unixtime * 1000).toFormat('d日T')
      } else if (type === 1) {
        return DateTime.fromMillis((unixtime - unixtime % 1800000) * 1000).toLocal().toFormat('kkkkMMdd_HHmm')
      }
    }
  }
}
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>
.tabBtn{
  width: 100%;
  max-width: 624px;
  display: flex;
  margin: 0 auto;
  background: #B5E8EF;
  margin-top: 20px;
}
.tabBtn a{
  width: 50%;
  height: 60px;
  text-align: center;
  display: block;
  line-height: 60px;
  cursor: pointer;
}
.tabBtn .active{
  background: #02BAD2;
}
h3{
  color: #73C700;
  font-size: 24px;
  margin: 0;
}
h4{
  margin: 0;
  color: #999;
  font-size: 20px;
}
.price{
  margin: 0;
  color: #333;
  font-size: 28px;
  font-weight: bold;
}
.sp{
  display: none;
}
.historyTable{
  width: 100%;
  max-width: 624px;
  margin: 20px auto 20px;
}
.historyTable tr:nth-child(even){
  background: #eee;
}
.historyTable td{
  text-align: center;
  vertical-align: middle;
  padding: 5px 0;
}
.historyTable th{
  vertical-align: middle;
  padding: 5px 0;
}
.voteBtn{
  border: none;
  display: inline-block;
  width: 30px;
  height: 30px;
  border-radius: 50%;
  background: #fff;
  cursor: pointer;
  transition: 200ms linear opacity;
}
.voteBtn:hover{
  opacity: 0.8;
}
.voteBtn img{
  position: relative;
  top: 8px;
  text-align: center;
  max-width: 60%;
}
.voteBtn.high{
  background: #00A6FB;
  transform: rotate(180deg);
}
.voteBtn.low{
  background: #FE4A49
}
@media all and (max-width: 740px) {
  .sp{
    display: inline-block;
  }
  h3{
    font-size: 18px;
  }
  h4{
    font-size: 14px;
  }
  .price{
    font-size: 18px;
  }
}
@media all and (max-width: 480px) {
  .tabBtn{
    width: 90%;
  }
  .tabBtn a{
    height: 40px;
    line-height: 40px;
    font-size: 14px;
  }
  .historyTable{
    font-size: 12px;
  }
  .voteBtn{
    width: 30px;
    height: 30px;
  }
  .voteBtn img{
    top: 8px;
  }
}
</style>



// WEBPACK FOOTER //
// src/components/Charts.vue